import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { DrawdownIncomeReviewDetailsModel } from '../../Models/Models/Processes/Drawdown/DrawdownIncomeReviewDetailsModel';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownIncomeReviewDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<DrawdownIncomeReviewDetailsModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownIncomeReviewDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<DrawdownIncomeReviewDetailsModel, any>(url, data);
  }
  public put(model: DrawdownIncomeReviewDetailsModel): Promise<DrawdownIncomeReviewDetailsModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Drawdown/DrawdownIncomeReviewDetails/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.put<DrawdownIncomeReviewDetailsModel, any>(url, data);
  }
}

